export const environment = {
  production: false,
  hostUrl: 'https://dev-kbank-dinning.vthgdigital.com',
  apiUrl: 'https://dev-kbank-dinning.vthgdigital.com/api/',
  feRedirectUrl: 'https://dev-kbank-dinning.vthgdigital.com/',
};
